/*
 * Store change: the product page's review and question forms (sections/product-reviews.liquid). Ported from
 * frankaggregate's product-reviews.js: open and close the two forms and submit them with fetch so the buyer stays
 * on the page. Without JS the form posts as is and the service redirects back with ?review=sent or ?review=error.
 */
const root = document.getElementById('reviews');

if (root) {
  const notice = root.querySelector('[data-reviews-notice]');
  const forms = [...root.querySelectorAll('[data-reviews-form]')];
  const opened = new Map();
  const SENT = {
    review: 'Thank you. Your review is in and will show here once we have checked it.',
    question: 'Question sent. We answer by email and post the answer here once it is checked.',
  };
  const FAILED = 'Could not send. Please try again.';

  const say = (text) => {
    notice.textContent = text || '';
    notice.hidden = !text;
  };
  const closeAll = () => forms.forEach((form) => (form.hidden = true));

  root.querySelectorAll('[data-reviews-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const which = button.getAttribute('data-reviews-open');
      closeAll();
      say(null);
      const form = root.querySelector(`[data-reviews-form="${which}"]`);
      if (!form) return;
      form.hidden = false;
      opened.set(form, Date.now());
      form.querySelector('input[type=radio], input[type=text], textarea')?.focus();
    });
  });

  root.querySelectorAll('[data-reviews-cancel]').forEach((button) => button.addEventListener('click', closeAll));

  forms.forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const photos = form.elements.photos?.files;
      if (photos && photos.length > 4) return say('Up to 4 photos, please.');
      if (photos && [...photos].some((file) => file.size > 8 * 1024 * 1024)) return say('Photos up to 8 MB each, please.');

      form.elements.t.value = String(Date.now() - (opened.get(form) || Date.now()));
      const submit = form.querySelector('button[type=submit]');
      submit.disabled = true;
      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' },
        });
        const data = await response.json().catch(() => ({}));
        if (data.ok) {
          form.reset();
          closeAll();
          say(SENT[form.getAttribute('data-reviews-form')] || SENT.review);
        } else {
          say(data.error || FAILED);
        }
      } catch {
        say(FAILED);
      } finally {
        submit.disabled = false;
        notice.scrollIntoView({ block: 'nearest' });
      }
    });
  });

  // The plain form post (no JS) came back with a flag.
  const params = new URLSearchParams(window.location.search);
  if (params.get('review') === 'sent') say(SENT[params.get('type')] || SENT.review);
  if (params.get('review') === 'error') say(params.get('msg') || FAILED);
}
